import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { App } from '@gin-betting/core';

import { AsyncSearchMobile } from 'modules/search/async';
import useSearch from './useSearch';
import { LocalRouts } from 'app-constants';

const SearchPage: React.FC<{}> = () => {
    const { isCompact } = useSearch();

    return (
        <Switch>
            {isCompact ? (
                <Route
                    exact={true}
                    path={LocalRouts.SEARCH}
                    component={() => {
                        return <AsyncSearchMobile />;
                    }}
                />
            ) : (
                <Redirect to={App.Routes.UPCOMING_LIST} />
            )}
        </Switch>
    );
};

export default SearchPage;
